import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, ButtonGroup, Modal } from 'semantic-ui-react';
import { runTask } from '../../redux/actions/tasks';
import ErrorBoundary from '../Common/ErrorBoundary';
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';

const RunTask = ({ id }: any) => {
  const dispatch = useDispatch();
  const [runWithPrams, setRunWithParams] = useState<boolean>(false);
  const [taskParams, setTaskParams] = useState<any | undefined>({});

  const handleRunTask = () => {
    dispatch(runTask(id));
  };
  const handleRunTaskWithParams = () => {
    if (Object.keys(taskParams).length > 0) dispatch(runTask(id, taskParams));
    setRunWithParams(false);
  };

  const onChange = (data: any) => {
    setTaskParams(data);
  };

  return (
    <div>
      <ButtonGroup>
        <Button negative onClick={handleRunTask}>
          Run Task
        </Button>
        <Button.Or />
        <Button onClick={() => setRunWithParams(true)}>
          Run with parameters
        </Button>
      </ButtonGroup>
      <Modal open={runWithPrams} onClose={() => setRunWithParams(false)}>
        <Modal.Content>
          <div style={{ maxHeight: '100%' }}>
            <ErrorBoundary>
              <Editor
                style={{ height: 500 }}
                value={taskParams}
                onChange={onChange}
                mode={'code'}
                htmlElementProps={{
                  style: { minHeight: 400, height: 400 },
                }}
                allowedModes={['tree', 'code']}
              />
            </ErrorBoundary>
          </div>
          <Modal.Actions>
            <Button negative onClick={handleRunTaskWithParams}>
              Run Task
            </Button>
          </Modal.Actions>
        </Modal.Content>
      </Modal>
    </div>
  );
};

export default RunTask;
